import type { Template } from "@/types";

export const SQ_07_H2_V5: Template[] = [
    {
        id: "sq-07-h2v5-01",
        name: "SQ 01 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 154, width: 306, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 363, width: 306, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 154, width: 271, height: 409, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 51, width: 207, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 363, width: 207, height: 303, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 51, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 363, width: 206, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-02",
        name: "SQ 02 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 154, width: 306, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 362, width: 306, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 154, width: 271, height: 409, rotation: 0, imageRotation: 0 },
            { id: "4", x: 790, y: 72, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1229, y: 72, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1229, y: 266, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1229, y: 460, width: 130, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-03",
        name: "SQ 03 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 72, width: 569, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 381, width: 386, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 381, width: 175, height: 264, rotation: 0, imageRotation: 0 },
            { id: "4", x: 791, y: 72, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1230, y: 72, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1230, y: 266, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1230, y: 460, width: 130, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-04",
        name: "SQ 04 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 72, width: 436, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 363, width: 436, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 518, y: 72, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 518, y: 266, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 460, width: 125, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 791, y: 142, width: 281, height: 433, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 142, width: 280, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-05",
        name: "SQ 05 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 139, width: 291, height: 215, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 362, width: 291, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 372, y: 139, width: 269, height: 438, rotation: 0, imageRotation: 0 },
            { id: "4", x: 791, y: 72, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1230, y: 72, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1230, y: 266, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1230, y: 460, width: 130, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-06",
        name: "SQ 06 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 124, y: 79, width: 413, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 124, y: 363, width: 413, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 545, y: 79, width: 380, height: 559, rotation: 0, imageRotation: 0 },
            { id: "4", x: 933, y: 79, width: 184, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 933, y: 363, width: 184, height: 275, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1125, y: 79, width: 184, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1125, y: 363, width: 184, height: 275, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-07",
        name: "SQ 07 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 512, y: 79, width: 414, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 124, y: 362, width: 418, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 124, y: 79, width: 186, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 79, width: 186, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 550, y: 362, width: 184, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 742, y: 362, width: 184, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 934, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-08",
        name: "SQ 08 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 187, width: 223, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 231, y: 187, width: 223, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 462, y: 187, width: 505, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 975, y: 187, width: 223, height: 343, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1206, y: 187, width: 235, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1206, y: 353, width: 110, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1324, y: 353, width: 110, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h2v5-09",
        name: "SQ 09 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 139, width: 289, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 139, width: 288, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 66, y: 350, width: 141, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 215, y: 350, width: 140, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 363, y: 350, width: 140, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 511, y: 350, width: 140, height: 227, rotation: 0, imageRotation: 0 },
            { id: "7", x: 934, y: 0, width: 500, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-07-h2v5-10",
        name: "SQ 10 - H2V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h2_v5_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 139, width: 585, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 76, width: 585, height: 394, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 478, width: 111, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 478, width: 111, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1021, y: 478, width: 111, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1140, y: 478, width: 110, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1258, y: 478, width: 110, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

];
